var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseToast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6891 10.2248C12.1036 10.6398 12.1036 11.2853 11.6891 11.7003C11.4818 11.9078 11.2284 12 10.952 12C10.6756 12 10.4223 11.9078 10.215 11.7003L6 7.48127L1.78503 11.7003C1.57774 11.9078 1.32438 12 1.04798 12C0.771593 12 0.518234 11.9078 0.31094 11.7003C-0.103647 11.2853 -0.103647 10.6398 0.31094 10.2248L4.52591 6.00576L0.31094 1.78674C-0.103647 1.37176 -0.103647 0.726225 0.31094 0.311239C0.725528 -0.103746 1.37044 -0.103746 1.78503 0.311239L6 4.53026L10.215 0.311239C10.6296 -0.103746 11.2745 -0.103746 11.6891 0.311239C12.1036 0.726225 12.1036 1.37176 11.6891 1.78674L7.47409 6.00576L11.6891 10.2248Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseToast);
export default __webpack_public_path__ + "static/media/closeToast.8a73a8bb7fe758f332f90b80c75975f0.svg";
export { ForwardRef as ReactComponent };